module.exports = __webpack_public_path__ + "static/media/it.5a3412cb.svg";